export default {
  'YouTube and High Definition Videos': 'YouTube y vídeos de alta definición',
  'Story videos (Instagram/Snaps/TikTok)': 'Vídeos de historias (Instagram/ Snaps/TikTok)',
  'Facebook and Instagram Feed videos': 'Vídeos de Facebook e Instagram Feed',
  'Facebook and Twitter Portrait Videos': 'Vídeos de retratos de Facebook y Twitter',
  'Twitter and Facebbok Landscape Videos': 'Vídeos de paisajes de Twitter y Facebbok',
  'Facebook Cover Videos And Blog Banners': 'Vídeos de portadas de Facebook y banners de blogs',
  'Fit': 'Ajuste',
  'Fill': 'Relleno',
}